import React from 'react';
import Slider from 'react-slick';
import './style.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GallerySection = () => {
    const images = [
        { src: require('../../images/blog/img-1.jpg'), alt: 'Gallery Image 1' },
        { src: require('../../images/blog/img-2.jpg'), alt: 'Gallery Image 2' },
        { src: require('../../images/blog/img-3.jpg'), alt: 'Gallery Image 3' },
        { src: require('../../images/blog/img-4.jpg'), alt: 'Gallery Image 4' },
        { src: require('../../images/blog/img-5.jpg'), alt: 'Gallery Image 5' },
        { src: require('../../images/blog/img-6.jpg'), alt: 'Gallery Image 6' },
        { src: require('../../images/blog/img-7.jpg'), alt: 'Gallery Image 7' },
        { src: require('../../images/blog/img-8.jpg'), alt: 'Gallery Image 8' },
        { src: require('../../images/blog/img-9.jpg'), alt: 'Gallery Image 9' },
        { src: require('../../images/blog/img-10.jpg'), alt: 'Gallery Image 10' },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    return (
        <section className="gallery-section">
            <div className="container">
                <div className="section-title">
                    <span className="section-subtitle">Celebrating Heritage</span>
                    <h2>Our Cultural Journey</h2>
                    <p>Explore a collection of moments that celebrate our cultural roots — from dance and music to art and community togetherness.</p>
                </div>
                <div className="gallery-carousel">
                    <Slider {...settings}>
                        {images.map((image, index) => (
                            <div key={index} className="gallery-item">
                                <img src={image.src} alt={image.alt} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default GallerySection;
